import { NotificationService } from "@3gaam/api/services";
import {
  RegisterClientInput,
  RegisterClientOutput,
} from "@3gaam/api/types/notification";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MessagePayload } from "firebase/messaging";

export interface Message extends MessagePayload {
  showAsNotification: boolean;
}

export interface NotificationState {
  messages: Message[];
  notification: {
    registerInfo?: RegisterClientOutput;
    disabled: boolean;
  };
}

const initializeNotificationRegisterInfo = (): RegisterClientOutput => {
  const registerInfo = JSON.parse(
    localStorage.getItem("notificationData") || "{}",
  ) as RegisterClientOutput;

  return registerInfo;
};

const initialState: NotificationState = {
  messages: [],
  notification: {
    registerInfo: initializeNotificationRegisterInfo(),
    disabled: false,
  },
};

export const registerNotificationTokenAction = createAsyncThunk<
  RegisterClientOutput,
  RegisterClientInput
>(
  "planning/generateTimetable",
  async (payload: RegisterClientInput, thunkAPI) => {
    const res = await NotificationService.register(payload);
    return res.data as RegisterClientOutput;
  },
);

export const notifSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    deleteMessageAction: (
      state,
      action: PayloadAction<{ messageId: Message["messageId"] }>,
    ) => {
      state.messages = state.messages?.filter(
        (i) => i.messageId !== action.payload.messageId,
      );
    },
    addMessageAction: (state, action: PayloadAction<Message>) => {
      const notification = action.payload;

      if (
        notification.messageId === null ||
        notification.messageId === undefined
      ) {
        return;
      }

      state.messages?.push(notification);
    },
    updateMessageByIdAction: (
      state,
      action: PayloadAction<{
        messageId: Message["messageId"];
        message?: Exclude<Partial<Message>, Message["messageId"]>;
      }>,
    ) => {
      const index = state.messages?.findIndex(
        (m) => m.messageId === action.payload.messageId,
      );
      if (index >= 0 && index !== null && index !== undefined) {
        state.messages[index] = {
          ...state.messages[index],
          ...action.payload.message,
        };
      }
    },
    disableNotificationsAction: (state) => {
      state.notification.disabled = true;
    },

    enableNotificationsAction: (state) => {
      state.notification.disabled = false;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(
      registerNotificationTokenAction.fulfilled,
      (state, action) => {
        localStorage.setItem(
          "notificationData",
          JSON.stringify(action.payload),
        );
        state.notification.registerInfo = action.payload;
      },
    );
  },
});

export const {
  addMessageAction,
  deleteMessageAction,
  disableNotificationsAction,
  enableNotificationsAction,
  updateMessageByIdAction,
} = notifSlice.actions;

export default notifSlice.reducer;
